import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Layout constants for consistent spacing
export const LAYOUT_CONSTANTS = {
  NAVBAR_HEIGHT: 'pt-16', // 64px - matches fixed navbar height
  NAVBAR_HEIGHT_PX: 64,
} as const
